// Welcome-email notice shown on every newsletter sign-up form: the full page
// (portal/src/NewsletterPage.jsx), the iframe embed
// (server/src/routes/embedTemplates/newsletter.js) and native RebelMouse forms
// through the SDK (portal/sdk/src/lib/newsletter/form.js). Owner decision
// 2026-10-28: a sign-up through a form that visibly shows this notice records
// the publisher onboarding permission, so forms send NOTICE_VERSION with the
// sign-up. New copy needs a new version, accepted by Milla and by the server
// (server/config/publisherEmailRollout.js) before forms send it.
const NOTICE_VERSION = 'welcome-v1';
// Québec newsletter copy addresses readers with "tu".
const NOTICE_COPY = {
  en: "You'll get the newsletters you choose, plus a few welcome emails about our app and our best long reads. Unsubscribe anytime.",
  fr: 'Tu recevras les infolettres choisies, plus quelques courriels de bienvenue sur notre appli et nos meilleurs longs formats. Désabonnement en tout temps.'
};
module.exports = { NOTICE_VERSION, NOTICE_COPY };
